module.exports = __webpack_public_path__ + "static/media/sriracha-teen-hero-desktop.7e8a6e79.jpg";